import { checkIfOpen } from './checkIfOpen';
import { getNextTimeEvent } from './getNextTimeEvent';

const DEALER_PHOTO_BASE_URL =
	'https://ddc-account-assets.ddcplatform.dealer.com/dealerphoto';

/**
 * Returns the dealer photo base URL, using the non-prod CDN host
 * when running on a non-prod (web-np) environment.
 * Uses window.location.hostname for env detection — same approach as
 * the LDP image-default widget in cms-web (LOCATION_DETAILS_V1.js).
 */
const getDealerPhotoBaseUrl = () => {
	const hostname = window?.location?.hostname || '';
	if (hostname.includes('web-np')) {
		return DEALER_PHOTO_BASE_URL.replace('ddcplatform', 'ddcplatform-np');
	}
	return DEALER_PHOTO_BASE_URL;
};

/**
 * Builds an array of LocationTile objects from a locationsResponse array.
 *
 * @param {LocationTile[]} locationsResponse - The array of location objects to transform.
 * @param {string} locationDetailPagePart - The URL part for location detail pages.
 * @returns {LocationTileData[]} Array of LocationTile objects.
 */
export const buildLocationTiles = (
	locationsResponse,
	locationDetailPagePart
) => {
	if (!Array.isArray(locationsResponse)) return [];
	return locationsResponse.map((location) => {
		const nameComaIndex = location.name.indexOf(',');
		const name =
			nameComaIndex !== -1
				? location.name.slice(0, nameComaIndex)
				: location.name;
		const now = new Date();
		const currentDay = now
			.toLocaleString('en-us', {
				weekday: 'long',
				timeZone: location.timeZoneId
			})
			.toLowerCase();
		const currentTime = now.toLocaleTimeString('en-us', {
			hour: '2-digit',
			minute: '2-digit',
			hour12: true,
			timeZone: location.timeZoneId
		});
		// Check if the location is open now
		const isOpen = checkIfOpen(
			location.hours,
			currentDay,
			currentTime.replace(/\s/g, '')
		);
		const openCloseText = getNextTimeEvent(
			location.hours,
			currentDay,
			currentTime.replace(/\s/g, '')
		);
		const href = `${locationDetailPagePart}/${encodeURIComponent(
			name.replace(/\s+/g, '-')
		)}/${encodeURIComponent(location.city.replace(/\s+/g, '-'))}.htm`;

		// Build dealer photo URL from the location's account ID.
		// Falls back to null so wsm-tiles Media component uses its
		// built-in placeholder image when no ID is available.
		const dealershipImgUrl = location.id
			? `${getDealerPhotoBaseUrl()}/${location.id}.jpg`
			: null;

		return {
			location: {
				...location,
				address1: '',
				name,
				distance: location.distance.toFixed(0), // truncate distance to 0 decimal places
				isOpen,
				openCloseText,
				dealershipImgUrl,
				href
			},
			displayType: 'media'
		};
	});
};
